import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

/**
 * "My Integrations" and "Available Integrations" are mutually exclusive
 * states of the same feature (installed list vs. catalog) — this renders
 * both as a single toggle so exactly one is ever highlighted, and clicking
 * the other navigates there. Used in the same toolbar slot on both pages
 * (next to "Add Integration" on /integrations, in place of the old
 * standalone link on /integrations/available).
 *
 * Uses react-bootstrap's <Button> (same as EntityOperationBar's Add/Edit/
 * Delete buttons) rather than plain HTML buttons + `btn-sm`, so the height
 * matches the rest of the toolbar exactly.
 */
const IntegrationsViewToggle = ({ current }) => {
    const navigate = useNavigate();

    return (
        <div className="integrations-view-toggle" role="group" aria-label="Integrations view">
            <Button
                variant={current === "my" ? "primary" : "outline-primary"}
                onClick={() => navigate("/integrations")}
            >
                <i className="fa fa-list-ul me-1" />
                My Integrations
            </Button>
            <Button
                variant={current === "available" ? "success" : "outline-success"}
                onClick={() => navigate("/integrations/available")}
            >
                <i className="fa fa-th me-1" />
                Available Integrations
            </Button>
        </div>
    );
};

export default IntegrationsViewToggle;
